import { contains, NormalizedSearchTerm } from "client/Data/searching";

export type VisibilityNodeData = {
	id: string;
	name: string;
	createdOn: Date | null;
	isCollapsed: boolean;
	isVisible: boolean;
	children: readonly VisibilityNodeData[];
};


export function visibleUnderSearchTerm(
	node: VisibilityNodeData,
	normalizedSearchTerm: NormalizedSearchTerm | ""
): boolean {
	if (!normalizedSearchTerm) {
		return true;
	}

	const nodeItselfMatchesSearchTerm: boolean = contains(
		node.name,
		normalizedSearchTerm
	);

	return nodeItselfMatchesSearchTerm
		|| node.children.some(
			(c) => visibleUnderSearchTerm(c, normalizedSearchTerm)
		);
}

export function setVisibilityRecursive(
	node: VisibilityNodeData,
	newValue: boolean,
	searchTerm: NormalizedSearchTerm | ""
): VisibilityNodeData {
	const shouldApplyNewValueToVisibleNodesOnly: boolean = newValue;

	return {
		...node,
		isVisible: newValue,
		children: node.children
			.map(
				oldState => shouldApplyNewValueToVisibleNodesOnly
					&& !visibleUnderSearchTerm(oldState, searchTerm)
						? oldState
						: setVisibilityRecursive(
							oldState,
							newValue,
							searchTerm
						)
			)
	};
}